import React from 'react';
import {
    Modal, ModalBody, ModalContainer, ModalHeader, ModalTitle, ModalOverlay, ModalFooter,
    Toast, Button, Loading,
} from "spectre-react/dist/cjs";
import PropTypes from "prop-types";
import {fetchWagesTestParams, postWagesTestParams} from "../../../api";
import WagesParamsForm from "../../WagesParamsEditPage/WagesParamsForm";


class WagesTestParamsModal extends React.PureComponent {
    static propTypes = {
        onParamsSubmit: PropTypes.func.isRequired,
    }
    getDefaultState = () => ({
        isOpened: false,
        fetchState: 0, fetchError: undefined,
        submitState: 0, submitError: undefined,
        calcParams: undefined,
    });

    state = this.getDefaultState();

    openModal = () => this.setState({isOpened: true}, this.componentDidMount);
    closeModal = () => this.setState(this.getDefaultState());

    _paramsFormController = undefined;
    receiveController = (controller) => this._paramsFormController = controller;

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        this.setState({fetchState: 1, fetchError: undefined});

        try {
            const {params} = await fetchWagesTestParams();
            this.setState({fetchState: 2, calcParams: params});
        } catch (error) {
            console.error(error);
            this.setState({fetchState: 0, fetchError: error.message});
        }
    }

    onSubmit = async () => {
        const {params} = this._paramsFormController.getParams();

        this.setState({submitState: 1, submitError: undefined});

        try {
            await postWagesTestParams(params);
            this.setState({submitState: 2});
            this.closeModal();
            this.props.onParamsSubmit();
        } catch (error) {
            console.error(error);
            this.setState({submitState: 0, submitError: error.message});
        }
    }

    render() {
        if (!this.state.isOpened)
            return null;

        const {
            calcParams,
            fetchState, fetchError,
            submitState, submitError
        } = this.state;

        return (
            <Modal active className="modal-xl" id="wages-test-params-modal">
                <ModalOverlay onClick={this.closeModal}/>
                <ModalContainer>
                    <ModalHeader>
                        <Button className="btn-clear float-right" onClick={this.closeModal}/>
                        <ModalTitle className="h5">Режим подбора коэффициентов</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        {fetchState === 1 && <Loading large />}
                        {fetchError && <Toast error className="my-2">{fetchError}</Toast>}
                        {calcParams && <WagesParamsForm calcParams={calcParams} disableStartDateInput provideController={this.receiveController} />}
                    </ModalBody>
                    <ModalFooter className="text-left">
                        {submitError && <Toast error className="my-2">{submitError}</Toast>}

                        <Button primary loading={submitState === 1} onClick={this.onSubmit}>Отправить</Button>
                        <Button link onClick={this.closeModal} className="ml-2">Закрыть</Button>
                    </ModalFooter>
                </ModalContainer>
            </Modal>
        )
    }
}


export default WagesTestParamsModal;